import { FileService } from '../file.service';
import { AccountService } from '../auth/account.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { IFileParamsModel } from '../../utils/interfaces/file-params-model.interface';
import { getProductName } from '../../core/common';
import { ISettings } from '../../core/interfaces';
import { PromisesService } from '../auth/promises.service';

@Injectable({
    providedIn: 'root'
})
export class SettingFileService extends FileService {
    get urlParams(): IFileParamsModel {
        return {
            product: getProductName(),
            fileName: environment.settingsFileName,
        };
    }

    constructor(
        public http: HttpClient,
        public accountService: AccountService,
        private promisesService: PromisesService
    ) {
        super(http, accountService);
    }

    public async uploadSettingsFile(settings: ISettings) {
        const body = this.prepareBody(settings);
        await this.promisesService.put(this.uploadSettingsFile.name, async () => {
            await this.uploadFile(body);
        }, 200);
    }

    public async updateSettingsFile(settings: ISettings) {
        const body = this.prepareBody(settings);
        await this.updateFile(this.urlParams, body);
    }

    public async downloadSettingsFile() {
        return await this.downloadFile<ISettings>(this.urlParams);
    }

    private prepareBody(settings: ISettings): FormData {
        const blob = new Blob([JSON.stringify(settings)], { type: 'text/plain' });

        const body = new FormData();
        body.append('file', blob, environment.settingsFileName);
        body.append('product', getProductName());

        return body;
    }

    private async updateFile(params: any, body: FormData) {
        await this.promisesService.put(this.updateFile.name, async () => {
            await this.deleteFile(params);
            await this.uploadFile(body);
        }, 200);
    }
}
